export default [
    //FOR ADJUSTMENT MANAGER===============================================================================
    {
        key: "New Adjustments",
        status: "New Adjustments",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            },
            {
                buttonType: "action", //if relay it means it will just emit an event to show data. if action it will update db info
                endPoint: "deleteAdjustments",
                payLoad: {
                    id: "", //record Id To Update 
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Delete Confirmation",
                rejectReasonMessage: "Why Are you Deleting this Adjustments?",

                buttonLabel: "Delete",
                color: 'danger',
                icon: "icon-trash",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "Are you sure you want to Delete this Adjustments?",
                successMessage: "This Adjustments has been successfully Deleted",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]

    },
    {
        key: "View Pending Adjustment",
        status: "Submitted HOD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "View Approved Adjustment",
        status: "Approved Adjustment",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "View Rejected Adjustment",
        status: "Rejected Adjustment",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
   
    
    //FOR ADJUSTMENT Approver===============================================================================
    {
        key: "HOD Pending Approval",
        status: "Submitted HOD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "Approved Adjustment",
        status: "Approved Adjustment",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    //------------------------------------------------------------------------------------------

]